module.exports = __webpack_public_path__ + "img/es-lint.12670ee7.png";